import React from 'react';

const ContentSkeleton = () => (
  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
    {Array.from({ length: 6 }, (_, index) => (
      <div
        key={index}
        className="overflow-hidden border border-[#658d71] bg-[rgba(0,0,0,0.1)]"
      >
        <div className="aspect-video animate-pulse bg-[rgba(101,141,113,0.18)]" />
        <div className="flex flex-col gap-2 p-3">
          <div className="h-3 w-4/5 animate-pulse bg-[rgba(169,201,177,0.18)]" />
          <div className="h-3 w-3/5 animate-pulse bg-[rgba(169,201,177,0.12)]" />
          <div className="mt-2 h-8 animate-pulse bg-[rgba(101,141,113,0.12)]" />
        </div>
      </div>
    ))}
  </div>
);

export default ContentSkeleton;